import { Box, Skeleton } from "@mui/material";
import Grid from "@mui/material/Grid2";

export const ProfileSkeleton = () => {
  return (
    <Box>
      <Box
        sx={{
          border: "1px solid rgba(183, 124, 10, 0.18)",
          borderRadius: "18px",
          p: 3,
          mb: 4,
          background: "rgba(255,255,255,0.96)",
        }}
      >
        <Skeleton width={220} height={42} />
        <Skeleton width="60%" height={24} sx={{ mt: 1 }} />
        <Box sx={{ display: "flex", gap: 1, mt: 2, flexWrap: "wrap" }}>
          <Skeleton variant="rounded" width={120} height={32} />
          <Skeleton variant="rounded" width={140} height={32} />
          <Skeleton variant="rounded" width={110} height={32} />
        </Box>
      </Box>
      <Grid container spacing={2.5}>
        {[...Array(3)].map((_, index) => (
          <Grid size={12} key={index}>
            <Skeleton variant="rounded" height={176} />
          </Grid>
        ))}
      </Grid>
    </Box>
  );
};
